import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ----- Register the PWA service worker after the page is interactive.
// Skips registration during local development (`localhost`) so the SW
// doesn't cache create-react-app's hot-reload bundle, but kept on
// every other host so the production + preview environments both
// hydrate offline support.
if ("serviceWorker" in navigator) {
  const isLocalhost = ["localhost", "127.0.0.1", "[::1]"].includes(
    window.location.hostname,
  );
  if (!isLocalhost) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js", { scope: "/" })
        .catch(() => {
          /* registration failures are non-fatal */
        });
    });
  }
}
